import {inject, Injectable, signal, Signal, WritableSignal} from '@angular/core';
import {Util} from '../../util/util';
import {CustomerDataFrontendService} from './customer-data-frontend.service';

/**
 * Holds the state of the Customer Data Frontend's customer profile. The profile brings its own overlay, so the webapp
 * only has to render the web component and tell it which customer to show.
 */
@Injectable({providedIn: 'root'})
export class CustomerDataProfileService {
  private readonly customerDataFrontendService: CustomerDataFrontendService = inject(CustomerDataFrontendService);

  private readonly accountNumberState: WritableSignal<string> = signal<string>(undefined);

  /**
   * Account number of the customer whose profile is shown, undefined while no profile is open.
   */
  readonly accountNumber: Signal<string> = this.accountNumberState.asReadonly();

  /**
   * Shows the profile of the given customer, if the Customer Data Frontend is available for the current user. Loading
   * the web component's script is triggered here because the profile may be opened without the Customer Data Frontend
   * search having been used before.
   * @param accountNumber Retail CRM account number of the customer to show.
   */
  open(accountNumber: string): void {
    if (!accountNumber || !this.customerDataFrontendService.isEnabled()) {
      return;
    }
    Util.attachScript(this.customerDataFrontendService.getWebComponentScriptUrl())
      .catch((): void => console.error('[Webapp] [Customer data] Failed to load the customer data frontend script.'));
    this.accountNumberState.set(accountNumber);
  }

  close(): void {
    this.accountNumberState.set(undefined);
  }
}
